// extracted by mini-css-extract-plugin
export default {"diff":"Diff-module__diff--kMRJ4","diffTargetable":"Diff-module__diffTargetable--EgTRK","diffHeaderWrapper":"Diff-module__diffHeaderWrapper--TjN5s"};